import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SERVER_API } from '../../constants'

const buildReport = createAsyncThunk('landing/build-report', async ({ uid, email, videoUrl, videoId }) => {
  return axios.post(`${SERVER_API.BASE_URL}/build-report`, { user_id: uid, email, video_url: videoUrl, video_id: videoId }, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true
  })
    .then(response => {
      return { data: response.data };
    })
    .catch(error => {
      if (error.response.data) {
        return { error: error.response.data };
      } else {
        return { error };
      }
    });
});

export { buildReport };
